export { AddTeamInlineForm } from './AddTeamInlineForm';
export type {
  AddTeamInlineFormProps,
  AddTeamInlineFormFieldNames,
  InvestorFieldsConfig,
} from './AddTeamInlineForm';
